<template>
	<div class="group-media-links-wrapper">
		<div class="noMedia" v-if="noMedia">
			{{ $t('groupsettings_mediatray_links_none_yet') }}
		</div>
		<div class="group-media-links" ref="mediaLinks" @scroll="bottomVisible">
			<MediaItem
				v-for="link in links"
				:item="link"
				:created_at="link.resource.created_at"
				:key="link.id"
				@user="$emit('showProfileCard', link.user)"
			>
				<UnfurlCard :resource="link.resource" />
			</MediaItem>

			<IosSpinner v-if="showMoreSpinner" bottom="0" left="50%" />
		</div>

		<IosSpinner
			v-if="showSpinner"
			top="47%"
			left="0"
			right="0"
			style="margin-left: auto; margin-right: auto;"
		>
			<template #title>{{ $t('common_loader_loading_title') }}</template>
		</IosSpinner>
	</div>
</template>

<script>
import store from '@/store'
import IosSpinner from '@/components/IosSpinner'
import { post, getCancelToken } from '@/helpers/api'
import MediaItem from '@/components/GroupSettings/MediaItem'
import UnfurlCard from '@/components/Message/UnfurlCard'

export default {
	name: 'GroupMediaLinks',
	components: { IosSpinner, MediaItem, UnfurlCard },
	data() {
		return {
			store,
			bubble_id: null,
			everythingLoaded: false,
			latest: null,
			links: [],
			linksEl: null,
			loadHistoryCancelToken: null,
			loadingMore: false,
			noMedia: false,
			showMoreSpinner: false,
			showSpinner: false,
		}
	},

	emits: ['showProfileCard'],

	created() {
		this.bubble_id = this.$route.params.id
	},

	mounted() {
		this.getMessageHistory()
	},

	methods: {
		bottomVisible() {
			this.linksEl = this.$refs.mediaLinks

			if (
				this.linksEl.scrollHeight -
					this.linksEl.scrollTop -
					this.linksEl.clientHeight <
					1 &&
				this.everythingLoaded == false &&
				!this.loadingMore
			) {
				this.showMoreSpinner = true
				this.loadMoreMessages()
			}
		},

		getMessageHistory(latest) {
			if (this.loadingMore) {
				return
			}

			if (this.latest == null) {
				this.showSpinner = true
			}

			this.loadingMore = true

			let data = { resources: true, bubble_id: this.bubble_id }

			if (latest) {
				data.latest = latest
			}

			if (this.loadHistoryCancelToken) {
				this.loadHistoryCancelToken.cancel()
				this.loadHistoryCancelToken = null
			}

			this.loadHistoryCancelToken = getCancelToken()

			post('/api/v1/bubble.history', data, this.loadHistoryCancelToken)
				.then(({ data }) => {
					this.showSpinner = false
					this.loadingMore = false

					if (data.messages.length == 0) {
						this.noMedia = true
						this.everythingLoaded = true
					} else {
						this.showMoreSpinner = false
						this.links.push(...data.messages)

						if (data.pagesize === data.messages.length) {
							this.latest = Math.min(
								...data.messages.map((message) => message.id)
							)
						} else {
							this.everythingLoaded = true
						}
					}
				})
				.catch((error) => {
					console.error(error)
				})
		},

		loadMoreMessages() {
			this.getMessageHistory(this.latest)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.group-media-links {
	overflow-y: auto;
	overflow-x: hidden;
	height: calc(100vh - 285px);
	padding-right: 15px;

	:deep(.url-card) {
		max-width: 100%;
		margin: 4px 0 0 0;

		.unfurl-card-horz {
			border: 0;
			max-width: 100%;
			> img {
				height: 58px;
				width: 86px;
				object-fit: cover;
			}
		}
		#unfurlHorzCardDetails {
			padding: 0;
			margin-left: 8px;
			max-width: 290px;
			> [class*=' tocolor-'] {
				max-width: 100%;
			}
		}
	}
}

:deep(.left) {
	overflow: unset;
	text-overflow: unset;
}

.noMedia {
	position: absolute;
	top: 46%;
	left: calc(46% - 125px);
	width: 380px;
	font-family: 'Avenir-Medium';
	font-size: 28px;
	color: #4f5053;
	text-align: center;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.group-media-links-wrapper {
		.ios-spinner {
			background: var(--neutral-100) !important;
		}
	}
}
</style>
